import { render, staticRenderFns } from "./jmbiotechMapping.vue?vue&type=template&id=657d95ea&"
import script from "./jmbiotechMapping.vue?vue&type=script&lang=js&"
export * from "./jmbiotechMapping.vue?vue&type=script&lang=js&"
import style0 from "./jmbiotechMapping.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports